import { operationalRuleType } from "@agentcall/core/type"

const {
  AGENTCALL_CONSENT_OPTIONS,
  DESIGNATED_CONTRACTOR_OPTIONS,
  CONTRACTOR_CATEGORIES,
  ARRANGEMENT_LIMIT_OPTIONS,
} = operationalRuleType

export const REQUEST_METHOD_OPTIONS = [
  { key: "email", value: "メール" },
  { key: "fax", value: "FAX" },
  { key: "phone", value: "電話" },
] as const

// key から表示ラベルを引く。該当なしは "—"。
export function labelOf(
  options: ReadonlyArray<{ key: string; value: string }>,
  key: string | null | undefined
): string {
  return options.find((option) => option.key === key)?.value ?? "—"
}

// 運用ルール(現在値 or 履歴スナップショット)の共通項目
export type RuleSnapshotLike = {
  agentCallContractorApproval: string
  hasDesignatedContractor: string
  arrangementLimit?: string | null
}

export const consentLabel = (rule: RuleSnapshotLike) =>
  labelOf(AGENTCALL_CONSENT_OPTIONS, rule.agentCallContractorApproval)
export const designatedLabel = (rule: RuleSnapshotLike) =>
  labelOf(DESIGNATED_CONTRACTOR_OPTIONS, rule.hasDesignatedContractor)
export const limitLabel = (rule: RuleSnapshotLike) =>
  labelOf(ARRANGEMENT_LIMIT_OPTIONS, rule.arrangementLimit)
export const requestMethodLabel = (key: string | null | undefined) =>
  labelOf(REQUEST_METHOD_OPTIONS, key)
export const categoriesLabel = (categories: ReadonlyArray<string> | null | undefined) =>
  categories && categories.length > 0
    ? categories.map((category) => labelOf(CONTRACTOR_CATEGORIES, category)).join("、")
    : "—"

// 一覧表示用に運用ルールを1行サマリにする(E-13)。
export function ruleSummary(rule: RuleSnapshotLike): string {
  return `手配承諾: ${consentLabel(rule)} ／ 指定業者: ${designatedLabel(rule)} ／ 手配上限: ${limitLabel(rule)}`
}
